<template>
  <div
    class="sb-selected-dropdown-search input-container full-height-width-center"
    data-sb-regression="sb-selected-dropdown-search-option"
    :class="{ 'is-disabled': disabled }"
  >
    <i
      aria-hidden="true"
      class="append sb-icon-search"
    />
    <SbTextInput
      :value="value"
      :placeholder="$t(placeholder)"
      readonly
    />
  </div>
</template>

<script>
import SbTextInput from '@src/components/Input/SbTextInput.vue';

/**
 * This is a helper component to be used in the `selection` slot of SbDropdownSearch.
 * This component renders an input that is readonly so that it is styled the same as the dropdown search input.
 */
export default {
  name: 'SbSelectedDropdownSearchOption',
  components: {
    SbTextInput,
  },
  props: {
    /**
     * This is the value to be displayed in the input box.
     */
    value: {
      type: [String, Number],
      default: null,
    },
    /**
     * Placeholder to be displayed when the component loads
     */
    placeholder: {
      type: String,
      default: 'sbDropdown.selectOneOrMore',
    },
  },
  computed: {
    disabled() {
      return this.$parent && this.$parent.disabled;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@src/components/Input/style/sb-text-input.scss';

@import '@src/components/Dropdown/style/sb-selected-dropdown-search-option.scss';

</style>
